import React, { useState } from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { Outlet } from 'react-router-dom';
import salesgrotopbar3 from '../../assets/images/salesgrotopbar3.png';
import FeatureSlideshow from '../common/FeatureSlideshow';

const AuthLayout = () => {
  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      {/* Left side - Logo and form */}
      <Grid 
        item 
        xs={12} 
        md={6}
        sx={{ 
          display: { xs: 'none', md: 'block' },
          minHeight: '100vh'
        }}
      >
        <FeatureSlideshow />
      </Grid>
      
      {/* Right side - Logo and form */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          background: 'linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 50%, #E2E8F0 100%)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          p: { xs: 2, sm: 3 },
          position: 'relative',
          minHeight: { xs: '100vh', md: '100vh' },
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
              radial-gradient(circle at 80% 20%, rgba(139, 92, 246, 0.03) 0%, transparent 50%),
              radial-gradient(circle at 20% 80%, rgba(16, 185, 129, 0.03) 0%, transparent 50%),
              radial-gradient(circle at 60% 60%, rgba(6, 182, 212, 0.02) 0%, transparent 50%)
            `,
            zIndex: 1
          }
        }}
      >
        {/* Logo Image */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: { xs: 0, sm: 2 },
            width: '100%',
            position: 'relative',
            zIndex: 2
          }}
        >
          <img src={salesgrotopbar3} alt="SalesGro Logo" style={{ maxWidth: '220px', width: '100%', height: 'auto', objectFit: 'contain' }} />
        </Box>

        {/* Form Container - no inner scroll; page scroll only if needed */}
        <Container
          maxWidth="sm"
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            p: 0,
            position: 'relative',
            zIndex: 2,
            flex: { xs: '1 1 auto', md: '0 0 auto' },
            overflow: 'visible',
          }}
        >
          <Outlet />
        </Container>
      </Grid>
    </Grid>
  );
};

export default AuthLayout;